module.exports = __webpack_public_path__ + "static/media/Sun-14.6ae2cced.png";